import {Inject, Injectable} from '@angular/core';
import has from 'lodash/has';
import {RtTitlesConfig, RtTitlesConfigToken} from './config';

@Injectable()
export class RtTitlesService {
  constructor(@Inject(RtTitlesConfigToken) private config: RtTitlesConfig) {
  }

  public formatTitle = (parts: void | string | string[], siteName: string = this.config.titleDefault): string => {
    if (!parts) {
      return siteName;
    }
    if (!Array.isArray(parts)) {
      parts = [parts];
    } else {
      parts = [...parts]; //remove readOnly flag
    }
    parts.push(siteName);
    return parts.join(this.config.titleSeparator);
  };

  public setTitle = (data: {title: any}) => {
    return has(data, 'title') ? data.title : 'Static page';
  };

}
